


























































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { objectIsEmpty } from '~/utils/common.js';
import { storeLinks } from '~/utils/app-config';

@Component({
  middleware: 'noauth',
  computed: {
    ...mapState('lang', {
      locale: 'locale',
    }),
    ...mapState('website', [
      'content',
    ]),
  },
  head () {
    const self: any = this;
    const description = self.content?.content.match(new RegExp('<p>' + "(.*)" + '</p>')) || '';
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.$t('explorer.routes.downloadLabel')} - On Piste`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description ? description[0].trim().replace(/<\/?[^>]+(>|$)/g, "") : '',
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.$t('explorer.routes.downloadLabel')} - On Piste`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description ? description[0].trim().replace(/<\/?[^>]+(>|$)/g, "") : '',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: `https://www.onpiste.com/img/corporate/app_banner.jpg`,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}onpiste-app`,
        },
      ],
    };
  },
  async fetch () {
    const self: any = this;
    await self.$store.dispatch('website/getPage', {
      type: 'DOWNLOAD',
      lang: self.$store.state.lang.locale,
    });
  },
})
export default class Download extends Vue {
  locale: string;
  content: {content: string};
  storeLinks = storeLinks;

  /* Computed skeleton handle */
  get contentIsEmpty () {
    return objectIsEmpty(this.content);
  }
}
